<template>
    <div class="login-page">
        <div class="login-background">
        </div>
        <div class="login-form">
            <logo-icon />
            <form @submit.prevent="handleLogin">
                <div class="mb-4 mt-5">
                    <input type="email" class="form-control term-input" v-model="email" placeholder="E-mail" required />
                </div>

                <div class="input-group mb-4">
                    <input :type="passwordFieldType" class="form-control term-input" v-model="password"
                        placeholder="Senha" required />
                </div>

                <div class="d-grid">
                    <button type="submit" class="btn term-login-button rounded-pill">
                        <div class="spinner-border spinner-border-sm text-light" role="status" v-if="isLoading">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <div v-else>
                            LOGIN
                        </div>
                    </button>
                </div>
            </form>
            <p v-if="wrongCredentials" class="text-danger mt-3">{{ loginErrorMessage }}</p>
        </div>
    </div>
</template>

<script>
import LogoIcon from "./login-components/LogoIcon.vue"
import axios from "axios";
import { billingApiUrl } from "@/config/runtime-config";

export default {
    components: {
        "logo-icon": LogoIcon,
    },
    data() {
        return {
            email: '',
            password: '',
            showPassword: false,
            loginErrorMessage: 'email ou senha invalidos',
            wrongCredentials: false,
            isLoading: false
        }
    },
    props:{
    linkData: String,
  },
    computed: {

        passwordFieldType() {
            return this.showPassword ? 'text' : 'password';
        }
    },
    methods: {
        async handleLogin() {
            this.isLoading = true
            let data = JSON.stringify({
                email: this.email,
                password: btoa(this.password),
                link_data: this.linkData
            });

            let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${billingApiUrl()}term/auth`,
                headers: {
                    "Content-Type": "application/json",
                },
                data: data,
            };

            await axios.request(config).then((res) => {
                this.isLoading = false
                if(res.data.statusCode !== 201){
                    this.wrongCredentials = true
                }
                else {
                    this.$emit('login-success');
                }
            }).catch(() => {
                this.wrongCredentials = true
                 this.isLoading = false
            })
        }
    }
}
</script>
<style>
.login-page {
    width: 100vw;
    height: 100vh;
    display: flex;
}

.login-background {
    width: 65vw;
    background-image: url('../../assets/carousel-new-logo.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.login-form {
    width: 35vw;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.term-input {
    width: 25vw !important;
    border: 1px solid rgba(128, 128, 128, 0.312) !important;
    border-radius: 0 !important;
}

.term-login-button {
    background-color: #11A7B6 !important;
    color: white !important;
    font-family: sans-serif !important;
    width: 125px;
    justify-self: center;
    padding: 10px !important;
    font-size: 14px !important;

}
</style>